// extracted by mini-css-extract-plugin
export default {"componentWrapper":"Select_componentWrapper__VLI2+","isSpecial":"Select_isSpecial__X7cqt"};